import { WNextBase } from '../api/wnext-base';
import { ComputeInstanceSize, type InstanceType } from '../compute';

export interface WNextPricingOptions {
  salesTier?: string;
  billingPeriod?: string;
}

/**
 * Get the WNext pricing for a given app
 *
 * @param appID
 * @param size
 * @returns
 */
export async function getWNextPricing(
  appID: string,
  size?: ComputeInstanceSize,
  options?: WNextPricingOptions
): Promise<InstanceType> {
  const s = size || ComputeInstanceSize.Small;
  const price = await new PricingAPI().lookup(appID, s, options);
  return [s, parseFloat(price)];
}

export class PricingAPI extends WNextBase {
  async lookup(
    appID: string,
    size?: ComputeInstanceSize,
    options?: WNextPricingOptions
  ): Promise<string> {
    const query = new URLSearchParams({
      slug: appID,
      instance_size: size || '',
    });
    if (options?.salesTier) {
      query.set('sales_tier', options.salesTier);
    }
    if (options?.billingPeriod) {
      query.set('billing_period', options.billingPeriod);
    }
    const res = await this.unwrapRes(this.client.get(`/pricing?${query.toString()}`));
    return res.data.price;
  }
}
